interface IAnimationItemConfig {
	name: string;
	title: string;
	description: string;
}


export class AnimationItemState {
	name: string;
	loaded: boolean;
	data: any;
	title: string;
	description: string;

	constructor(init: IAnimationItemConfig) {
		this.name = init.name;
		this.loaded = false;
		this.data = null;
		this.title = init.title;
		this.description = init.description;
	}
}